import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socket from "../../utils/socketConnect.utils";
import {
  incrementNotification,
  decrementNotification,
  recieveUnpushTask,
  UpdateEndDateApproval,
  addSocketApprovalTask, 
} from "../../store/slices/taskmanagementSlice";
import { RootDispatch, RootState } from "../../store";

const GlobalSocketListener = () => {
  const dispatch = useDispatch<RootDispatch>();
  const currentUserId = useSelector((s: RootState) => s.auth.userId);

  useEffect(() => {
    if (!socket.connected) socket.connect();

    socket.on("connect", () => {

      const userId = currentUserId;
      socket.emit("join", { userId });
    });

    socket.on("task-updated", (data) => {

      if (!data?.task) return;
      const task = data.task;

      // Preferred: server should send recipients array
      const recipients: string[] | undefined = data.recipients;

      // Extract ids (works whether populated or plain id)
      const getId = (val: any) =>
        val?._id ? val._id.toString() : val?.toString();
      const authorId = getId(task.author);
      const assigneeId = getId(task.assignee);

      const isRecipient =
        Array.isArray(recipients) && recipients.length > 0
          ? recipients.some((r) => r === currentUserId)
          : authorId === currentUserId || assigneeId === currentUserId;

      if (!isRecipient) return;

      // NEW: push into socketApprovalTasks (upsert)
      dispatch(addSocketApprovalTask(task));

      // keep notification behavior
      if (data.type === "new-waiting-approval") {
        // increment only when current user is the author
        if (authorId === currentUserId) dispatch(incrementNotification());
      } else {
        // If status moved away from waiting for approval and current user is author, decrement
        if (
          authorId === currentUserId &&
          task.status !== "waiting for approval"
        ) {
          dispatch(decrementNotification());
        }
      }
    });

    socket.on("extend-date", (data) => {
      if (!data?.task) return;
      const task = data.task;
      const recipients: string[] | undefined = data.recipients;

      const getId = (val: any) =>
        val?._id ? val._id.toString() : val?.toString();
      const authorId = getId(task.author);
      const assigneeId = getId(task.assignee);

      const isRecipient =
        Array.isArray(recipients) && recipients.length > 0
          ? recipients.some((r) => r === currentUserId)
          : authorId === currentUserId || assigneeId === currentUserId;

      if (!isRecipient) return;

      dispatch(UpdateEndDateApproval(data.task));

      // Also add/upsert into socket approval array so the approval table can show it
      dispatch(addSocketApprovalTask(data.task));

      if (task.requestedEndDate) {
        dispatch(incrementNotification());
      } else {
        dispatch(decrementNotification());
      }
    });

    return () => {
      socket.off("task-updated");
      socket.off("extend-date");
    };
  }, [dispatch, currentUserId]);

  return null;
};

export default GlobalSocketListener;
